import { formatPropertyName } from './format';

declare global {
  interface Window {
    ga?: (...args: any[]) => void;
  }
}

/**
 * Reads data-gaeventname and data-gaclickname from element dataset.
 */
export function getGoogleAnalytics(element: Element): Record<string, string> {
  const data: Record<string, string> = {};
  if (element) {
    Object.keys((element as HTMLElement).dataset).forEach((key) => {
      const val = (element as HTMLElement).dataset[key];
      if (val && (key.startsWith('gaeventname') || key.startsWith('gaclickname'))) {
        data[formatPropertyName(key)] = val;
      }
    });
  }
  return data;
}

/**
 * Sends a legacy Universal Analytics event if ga() is available and data is present.
 */
export function sendLegacyGA(gaData: Record<string, string>): void {
  if (
    gaData?.gaeventname &&
    gaData?.gaclickname &&
    typeof window.ga === 'function'
  ) {
    window.ga('send', 'event', gaData.gaeventname, 'click', gaData.gaclickname);
  }
}
